import * as Types from '../../types/generated';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSuggestionsForRoleTitleQueryVariables = Types.Exact<{
  query: Types.Scalars['String']['input'];
  count: Types.Scalars['Int']['input'];
  countryCode: Types.Scalars['CountryCodeIso2']['input'];
  languageCode: Types.Scalars['LanguageCodeIso']['input'];
  session: Types.Scalars['String']['input'];
}>;

export type GetSuggestionsForRoleTitleQuery = {
  ontologyRoleTitlesSeniority: Array<{
    __typename: 'IOntologyRoleTitleSeniority';
    id: string;
    normalisedText: string;
  }>;
};

export const GetSuggestionsForRoleTitleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSuggestionsForRoleTitle' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'query' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'count' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'countryCode' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CountryCodeIso2' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'languageCode' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LanguageCodeIso' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'session' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ontologyRoleTitlesSeniority' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'query' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'count' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'count' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'countryCode2' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'countryCode' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'languageCode' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'languageCode' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'session' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'session' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'normalisedText' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetSuggestionsForRoleTitleQuery__
 *
 * To run a query within a React component, call `useGetSuggestionsForRoleTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestionsForRoleTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestionsForRoleTitleQuery({
 *   variables: {
 *      query: // value for 'query'
 *      count: // value for 'count'
 *      countryCode: // value for 'countryCode'
 *      languageCode: // value for 'languageCode'
 *      session: // value for 'session'
 *   },
 * });
 */
export function useGetSuggestionsForRoleTitleQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSuggestionsForRoleTitleQuery,
    GetSuggestionsForRoleTitleQueryVariables
  > &
    (
      | { variables: GetSuggestionsForRoleTitleQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSuggestionsForRoleTitleQuery,
    GetSuggestionsForRoleTitleQueryVariables
  >(GetSuggestionsForRoleTitleDocument, options);
}
export function useGetSuggestionsForRoleTitleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSuggestionsForRoleTitleQuery,
    GetSuggestionsForRoleTitleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSuggestionsForRoleTitleQuery,
    GetSuggestionsForRoleTitleQueryVariables
  >(GetSuggestionsForRoleTitleDocument, options);
}
export function useGetSuggestionsForRoleTitleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSuggestionsForRoleTitleQuery,
        GetSuggestionsForRoleTitleQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSuggestionsForRoleTitleQuery,
    GetSuggestionsForRoleTitleQueryVariables
  >(GetSuggestionsForRoleTitleDocument, options);
}
export type GetSuggestionsForRoleTitleQueryHookResult = ReturnType<
  typeof useGetSuggestionsForRoleTitleQuery
>;
export type GetSuggestionsForRoleTitleLazyQueryHookResult = ReturnType<
  typeof useGetSuggestionsForRoleTitleLazyQuery
>;
export type GetSuggestionsForRoleTitleSuspenseQueryHookResult = ReturnType<
  typeof useGetSuggestionsForRoleTitleSuspenseQuery
>;
export type GetSuggestionsForRoleTitleQueryResult = Apollo.QueryResult<
  GetSuggestionsForRoleTitleQuery,
  GetSuggestionsForRoleTitleQueryVariables
>;
